import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Combobox } from '@wit-support/ui';
import { FieldShell } from './field-shell.js';
/** `meta.options` → варианты `Combobox` (подпись, значок, пояснение, слова поиска). */
export function toComboboxOptions(options) {
    return (options ?? []).map((o) => ({
        value: o.value,
        label: o.label,
        ...(o.icon != null ? { icon: o.icon } : {}),
        ...(o.description ? { description: o.description } : {}),
        ...(o.keywords ? { keywords: o.keywords } : {}),
    }));
}
/**
 * Bound multi-select. Reads its choices from `meta.options` ([{value,label}])
 * and stores the selected `value`s as a `string[]` on the field — the stored
 * shape is unchanged.
 *
 * Rendered as the kit `Combobox` (multiple): selected values are chips INSIDE
 * the input row, typing filters the list (case/diacritics-insensitive, by
 * label and value), click/Enter picks, Backspace drops the last chip.
 * `meta.max` (number) caps the selection.
 *
 * Registered ahead of the generic string-array chip input so an array field can
 * opt in via `meta.widget === 'multiselect'`; plain string arrays keep the chip
 * input.
 */
export function MultiSelectWidget(props) {
    const { field, fieldState, meta, label, description, hint, disabled, readonly } = props;
    const options = React.useMemo(() => toComboboxOptions(meta.options), [meta.options]);
    const selected = Array.isArray(field.value) ? field.value : [];
    const max = typeof meta.max === 'number' ? meta.max : undefined;
    return (_jsx(FieldShell, { meta: meta, fieldState: fieldState, label: label, description: description, hint: hint, htmlFor: field.name, children: _jsx(Combobox, { multiple: true, id: field.name, "aria-label": typeof (label ?? meta.label) === 'string' ? String(label ?? meta.label) : 'Выбор', options: options, value: selected, onChange: (next) => field.onChange(next), onBlur: field.onBlur, inputRef: field.ref, placeholder: meta.placeholder ?? 'Найти…', disabled: disabled === true || readonly === true, "aria-invalid": fieldState.invalid || undefined, ...(max != null ? { max } : {}) }) }));
}
//# sourceMappingURL=multiselect.js.map